// extracted by mini-css-extract-plugin
module.exports = {"itemsContainer":"CartMiniItems_itemsContainer__A8BJO","emptyContainer":"CartMiniItems_emptyContainer__V1biU"};